import { ReactNode } from "react";

export const AuthHeader = ({
  header,
  text,
}: {
  header: string | ReactNode;
  text: ReactNode;
}) => {
  return (
    <section className="flex w-full flex-col gap-2.5 text-center md:gap-3">
      <p className="font-dela text-[28px] leading-[28px] tracking-[-0.56px] text-ink md:text-[32px] md:leading-[32px] md:tracking-[-0.64px]">
        {header}
      </p>
      <p className="mx-auto max-w-[420px] font-onest text-base leading-6 tracking-[-0.32px] text-grey-700 md:text-lg md:leading-7 md:tracking-[-0.36px]">
        {text}
      </p>
    </section>
  );
};

